import { Gear } from '@phosphor-icons/react';

export default Gear;
